export default __webpack_public_path__ + "static/media/1.9162d1e3.jpg";